import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import axios from "axios";
import { environment } from "../../enviornments/enviornment";
import demoVideo from "../../assets/videos/harrypotter.mp4";

import {
    Card, CardImgOverlay, CardImg,
    CardTitle
} from "reactstrap";

import "./styles/MainCarousel.scss";

const MainMovieCarousel = (props) => {
    const settings = {
        centerMode: true,
        centerPadding: "0px",
        slidesToShow: 3,
        swipeToSlide: true,
        arrows: false,
        focusOnSelect: true,
        dots: false,
        infinite: true,
        className: "center",
        speed: 1000,
        autoplay: false,
        autoplaySpeed: 3000,
        responsive: [{
            breakpoint: 954,
            settings: {
                centerMode: false,
                slidesToShow: 2,
                centerPadding: "20px"
            }
        }, {
            breakpoint: 661,
            settings: {
                centerMode: false,
                slidesToShow: 1,
            }
        },
        {
            breakpoint: 400,
            settings: {
                centerMode: false,
                slidesToShow: 1,
                centerPadding: "20px"
            }
        }
        ]
    };
    const [data, setData] = useState([]);
    let url = props.dataUrl || "https://api.themoviedb.org/3/trending/all/day";
    useEffect(() => {
        axios.get(`${url}?api_key=${environment.MovieDbApi}`)
            .then(function (response) {
                // handle success
                setData(response.data.results);
            })
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .then(function () {
                // always executed
            });
    }, []);
    let layout = data.map((item, index) => {
        return (
            <Card inverse key={index}>

                <video key={index} className="card-img image-loading"
                    onMouseOver={(e) => e.target.play()}
                    onMouseOut={(e) => {
                        e.target.pause();
                        e.target.load();
                    }}
                    preload="none"
                    poster={`https://image.tmdb.org/t/p/w500/${window.innerWidth > 768 ? item.backdrop_path ? item.backdrop_path : item.poster_path : item.poster_path ? item.poster_path : item.backdrop_path}`}
                    src={demoVideo}>
                    Your browser does not support the <code>video</code> element.
              </video>
                <Link to={{
                    pathname: item.media_type == "movie" || Object.prototype.hasOwnProperty.call(item, "release_date") ? `/movies/${item.title ? item.title.split(" ").join("-") : item.name.split(" ").join("-")}/${item.id}` : `/tvshow/${item.title ? item.title.split(" ").join("-") : item.name.split(" ").join("-")}/${item.id}`,
                    state: {
                        // no idea why ! condition is working it should work without ! 😂
                        dataUrl: !item.media_type == "movie" || Object.prototype.hasOwnProperty.call(item, "release_date") ? `https://api.themoviedb.org/3/movie/${item.id}` : `https://api.themoviedb.org/3/tv/${item.id}`,
                    }
                }}>
                    <CardImgOverlay>
                        <CardTitle className="text-white">{item.title ? item.title : item.name}</CardTitle>
                    </CardImgOverlay>
                </Link>
            </Card>
        );
    });
    return (
        <div className="main-carousel-container container-fluid p-0 mt-3">
            <Slider {...settings} className="main-movie-slider">
                {layout}
            </Slider>
        </div>
    );
};

export default MainMovieCarousel;
